// The Go server injects <base href="..."> into index.html based on the
// BASE_PATH env var. Reading it at runtime lets a single image serve the SPA
// from / (legacy) or /greco/ (Fast Track-integrated) without rebuilding.
export function getBaseHref(): string {
  if (typeof document === 'undefined') return '/';
  const href = document.querySelector('base')?.getAttribute('href');
  return href || '/';
}
